export default {
  crashCoursePaymentList: [],
  crashCourseList: []

}
